import {createSlice, isAllOf, isRejected} from '@reduxjs/toolkit';

import {storage} from '@edna/utils';

import {EStorageKeys} from 'src/constants';
import {isMatchBackendUnavailableQuery, listenerMiddleware} from 'src/models';

export type TState = {
  isServiceAvailable: boolean;
  isMenuPinned: boolean;
};

const initialState = () => {
  const isMenuOpen = storage.get(EStorageKeys.MENU_OPEN);

  return {
    isServiceAvailable: true,
    isMenuPinned: isMenuOpen ? isMenuOpen === 'true' : true,
  };
};

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleMenuPinned(state) {
      state.isMenuPinned = !state.isMenuPinned;
    },
    setServiceAvailability(state, {payload}) {
      state.isServiceAvailable = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAllOf(isRejected, isMatchBackendUnavailableQuery), (state) => {
      state.isServiceAvailable = false;
    });
  },
});

export const {toggleMenuPinned, setServiceAvailability} = slice.actions;
export const selectIsServiceAvailable = (state: TRootState) => state.app.isServiceAvailable;
export const selectIsMenuPinned = (state: TRootState) => state.app.isMenuPinned;

listenerMiddleware.startListening({
  actionCreator: toggleMenuPinned,
  effect: (_, listenerApi) => {
    const isMenuPinned = selectIsMenuPinned(listenerApi.getState());

    storage.set(EStorageKeys.MENU_OPEN, String(isMenuPinned));
  },
});

export default slice.reducer;
